module.exports = require("colors");


//////////////////
// WEBPACK FOOTER
// external "colors"
// module id = 57
// module chunks = 0